export default "__VITE_ASSET__f03ba147__"